import { render, staticRenderFns } from "./ScoreDetailPage.vue?vue&type=template&id=ddca0cb0&scoped=true&"
import script from "./ScoreDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ScoreDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddca0cb0",
  null
  
)

export default component.exports